<ndt-mailbox-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [accountId]="accountId | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [mailboxPrivileges]="mailboxPrivileges$ | async"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
></ndt-mailbox-register-view>
